import { render, staticRenderFns } from "./index.vue?vue&type=template&id=62c4518f&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=62c4518f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c4518f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\demoAdmin\\chuangyueBlockchaimAdmin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c4518f')) {
      api.createRecord('62c4518f', component.options)
    } else {
      api.reload('62c4518f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=62c4518f&scoped=true&", function () {
      api.rerender('62c4518f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dynamic/topManagement/topicTag/index.vue"
export default component.exports